import { Link, useNavigate } from 'react-router-dom'

import UsersList from '../../components/users/list'
import RobotsList from '../../components/robots/list'
import FirstInvoiceLists from '../../components/robots/firstInvoiceLists'
import useQuery from '../../context/useQuery'

const AdminPanel = () => {
  const params = useQuery()
  const navigate = useNavigate()
  const tab = params.get('tab') === 'robots' ? 'robots' : 'users'

  const selectTab = (next: 'users' | 'robots') => {
    const query = new URLSearchParams(params)
    if (next === 'robots') query.set('tab', 'robots')
    else query.delete('tab')
    const search = query.toString()
    navigate(search ? `/admin?${search}` : '/admin')
  }

  return (
    <div>
      <Link to='/admin/playground'>Playground</Link>
      <br />
      <Link to='/admin/free-access'>Free access whitelist</Link>
      <ul className="nav nav-tabs mt-3" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            type="button"
            className={`nav-link ${tab === 'users' ? 'active' : ''}`}
            role="tab"
            aria-selected={tab === 'users'}
            onClick={() => selectTab('users')}
          >
            Users
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            type="button"
            className={`nav-link ${tab === 'robots' ? 'active' : ''}`}
            role="tab"
            aria-selected={tab === 'robots'}
            onClick={() => selectTab('robots')}
          >
            Robots
          </button>
        </li>
      </ul>
      <div className="mt-3">
        {tab === 'users' ? <UsersList /> : (
          <>
            <RobotsList />
            <FirstInvoiceLists />
          </>
        )}
      </div>
    </div>
  )
}

export default AdminPanel
